import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION31: PdfComponent = {
  type: 'section',
  id: 's31',
  title: '31. Severance',
  content: [
    {
      type: 'bulletList',
      id: 's31bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'If any provision of this Agreement (or part of any provision) is or becomes illegal, invalid or unenforceable, the legality, validity and enforceability of any other provision of this Agreement shall not be affected.',
        },
        {
          copy: 'If any provision of this Agreement (or part of any provision) is or becomes illegal, invalid or unenforceable but would be legal, valid and enforceable if some part of it were deleted or modified, the provision or part-provision in question shall apply with such deletions or modifications as may be necessary to make it legal, valid and enforceable.',
        },
        {
          copy: 'In the event of such deletion or modification, the parties shall negotiate in good faith in order to agree the terms of a mutually acceptable alternative provision.',
        },
      ],
      prefix: '31',
    },
  ],
};
